document.getElementById('footer').innerHTML="\
  <footer>\
    <a href='impressum.html'>&copy; CheckWata, 2018</a>\
  </footer>\
</body>\
</html>"


// WEBPACK FOOTER //
// ./src/js/footer.js